import React from 'react'
import { Linking } from 'react-native'
import { useTranslation } from 'react-i18next'
import { ServiceTitle, StyledContainer } from '../../../Appointment/style'
import { DefaultButtonWithText } from '../../../App/Components'
import { ActivityEdit } from '../ActivityEdit/ActivityEdit'
import { ISettingValues } from '../../../Settings/ISettings'
import { IPreviousAppointment } from '../../../PreviousAppointments/IPreviousAppointment'
import { SelectPersonForAllActivities } from '../../../Appointment/Components'
import { isSelectAPerson } from '../../../App/Util/selectPersonChecks/isSelectAPerson/isSelectAPerson'
import { customerPortalLinks } from '../../../App/Util/customerPortalUrl'

type Props = {
  establishmentId: string
  settingValues: ISettingValues
  prevAppointment: IPreviousAppointment
}

export const EditOverviewHeader = ({
  establishmentId,
  settingValues,
  prevAppointment,
}: Props) => {
  const { t } = useTranslation()

  return (
    <>
      <ServiceTitle fontcolor={settingValues.highlightColor}>
        {t('Services')}
      </ServiceTitle>
      <DefaultButtonWithText
        backgroundcolor={settingValues.backgroundColor}
        fontcolor={settingValues.highlightColor}
        customMargin="0 10px 8px"
        onPress={() => Linking.openURL(customerPortalLinks.appointments(establishmentId))}
      >
        {t('Back to appointments')}
      </DefaultButtonWithText>
      <StyledContainer highlightcolor={settingValues.highlightColor}>
        {prevAppointment.activities.map((activity) => {
          const isPreferredPerson = activity.persons.some(p => p.isPreferred)
          return (
            <ActivityEdit
              key={activity.id}
              isPersonSelectable={activity.isPersonSelectable}
              activity={activity}
              settingsValues={settingValues}
              isPreferredPerson={isPreferredPerson}
            />
          )
        })}
        <SelectPersonForAllActivities
          isPersonSelectable={isSelectAPerson(prevAppointment.activities)}
          moveAppointmentData={prevAppointment.activities}
        />
      </StyledContainer>
    </>
  )
}
